/**
 * @param {string} keyword
 * @param {string} location
 * @param {Object} filters
 * @constructor
 */
export function SearchParam(keyword, location, filters) {
    this.keyword = keyword;
    this.location = location;
    this.distance = filters['r'];
    this.datePosted = filters['dp'];
    this.salaryType = filters['st'];
    this.salaryMin = filters['sl'];
    this.salaryMax = filters['su'];
    this.jobType = filters['jt'];
    this.features = filters['f'];
    this.type = filters['type'];
    this.page = filters['pg'];
    this.uniqueId = filters['jb'];
}
